namespace Matrix.Data {
    export class DataVisualsColumns {
        static columnsKey = 'Data.DataVisuals';
    }
}
